import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from 'rxjs';

@Component({
  selector: "app-delete-box",
  templateUrl: "./delete-box.component.html",
  styleUrls: ["./delete-box.component.scss"]
})
export class DeleteBoxComponent implements OnInit {
  deleteConfirmMessage:string='';
  @Input() public Content: any;
  custommessage: string;
  header: string;
  heading:string;
  ProceedButtonName: string;
  TerminateButtonName: string;
  action: Subject<any> = new Subject();
  constructor(
    public modalRef: NgbActiveModal,
  ) { }

  ngOnInit() {

    this.Content.header = "Confirmation";
    if (this.Content.custommessage !== '' && this.Content.custommessage !== undefined)
      this.deleteConfirmMessage = this.Content.custommessage;
    else
      this.deleteConfirmMessage = "Selected Record(s) will be deleted. Do you want to proceed?";
    // if (this.heading === '' || this.heading === undefined)
    //   this.header = "Confirmation";
    //   else
    //   this.header=this.heading;
      if (this.Content.ProceedButtonName === '' || this.Content.ProceedButtonName === undefined)
      this.Content.ProceedButtonName = "Ok";

      if (this.Content.TerminateButtonName === '' || this.Content.TerminateButtonName === undefined)
      this.Content.TerminateButtonName = "Cancel";
  }

  showConfirm(): void {
     ;
    this.modalRef.close('okclick');
   // this.action.next('okclick');
   // this.toastrService.success(deleteSuccessMessage);
  }
  CancelClcik(): void {
     ;
    this.modalRef.close('cancelclick');
  //  this.action.next('cancelclick');
   // this.toastrService.success(deleteSuccessMessage);
  }

}
